import styled from 'styled-components';
import colors from '~/constants/colors';

export const Container = styled.div`
  width: 100%;
  position: relative;
`;

export const UploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px 20px;
`;

export const UploadText = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${colors.textColor};
`;

export const UploadHint = styled.div`
  font-size: 12px;
  color: ${colors.grey[500]};
`;

export const FileDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid ${colors.grey[300]};
  border-radius: 8px;
  background-color: ${colors.grey[50]};
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const FileName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.textColor};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${colors.red[500]};
  font-size: 18px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;

  &:hover {
    color: ${colors.red[600]};
    transform: scale(1.1);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ErrorMessage = styled.div`
  color: ${colors.errorColor};
  font-size: 12px;
  margin-top: 8px;
  padding: 8px 12px;
  background-color: ${colors.red[50]};
  border: 1px solid ${colors.red[200]};
  border-radius: 4px;
`;
